// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FormScroll.module.css */

.gapsy-form_customScrollForm__rCDXJ {
  display: block;
  max-height: 250px;
  overflow: hidden;
  position: relative;
  padding-right: 5px;
}

.gapsy-form_customScrollForm__rCDXJ:hover {
  overflow-y: auto;
}

.gapsy-form_customScrollForm__rCDXJ::-webkit-scrollbar {
  width: 6px;
}

.gapsy-form_customScrollForm__rCDXJ::-webkit-scrollbar-thumb {
  background-color: #7cbbc8;
  border-radius: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/gapsy-form.module.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["/* FormScroll.module.css */\r\n\r\n.customScrollForm {\r\n  display: block;\r\n  max-height: 250px;\r\n  overflow: hidden;\r\n  position: relative;\r\n  padding-right: 5px;\r\n}\r\n\r\n.customScrollForm:hover {\r\n  overflow-y: auto;\r\n}\r\n\r\n.customScrollForm::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.customScrollForm::-webkit-scrollbar-thumb {\r\n  background-color: #7cbbc8;\r\n  border-radius: 3px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customScrollForm": `gapsy-form_customScrollForm__rCDXJ`
};
export default ___CSS_LOADER_EXPORT___;
